/**
 * Helpers for threading the shared General Management insights filter
 * (case groups + creditors, plus optional base params like from/to) through
 * the cortex api + hook layer in a consistent way.
 */
/**
 * Builds a query string (including the leading `?`, or empty when there is
 * nothing to send) from a set of scalar base params and the shared
 * case-group/creditor arrays. Arrays are encoded as repeated params, e.g.
 * `caseGroupIds=a&caseGroupIds=b`.
 */
export const insightsQuery = ({ base = {}, scope = {}, } = {}) => {
    const params = new URLSearchParams();
    Object.entries(base).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            params.append(key, String(value));
        }
    });
    (scope.caseGroupIds ?? []).forEach((id) => params.append('caseGroupIds', id));
    (scope.creditorIds ?? []).forEach((id) => params.append('creditorIds', id));
    const query = params.toString();
    return query ? `?${query}` : '';
};
/**
 * Stable, order-independent cache-key fragment for the shared scope filter, so
 * two selections with the same ids (in any order) reuse the same query cache.
 */
export const insightsScopeKey = (scope = {}) => {
    const caseGroups = [...(scope.caseGroupIds ?? [])].toSorted().join(',');
    const creditors = [...(scope.creditorIds ?? [])].toSorted().join(',');
    return `cg:${caseGroups}|cr:${creditors}`;
};
//# sourceMappingURL=filter-params.js.map